import { defineStore } from 'pinia'

export const useAlertStore = defineStore('alert', {
  state: () => ({
    alert: {
      show: false,
      message: '',
      color: 'success'
    }
  }),
  actions: {
    showAlert(message: string, color: string, time: number = 5000) {
      this.alert.show = true
      this.alert.message = message
      this.alert.color = color
      setTimeout(() => {
        this.hideAlert()
      }, time)
    },
    hideAlert() {
      this.alert.show = false
      this.alert.message = ''
    }
  },
  getters: {
    getColor() {
      switch (this.alert.color) {
        case 'success':
          return 'green'
        case 'error':
          return 'red'
        case 'warning':
          return 'yellow'
        case 'info':
          return 'blue'
        default:
          return 'green'
      }
    }
  }
})

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    snackbar: {
      show: false,
      messages: [] as Array<string>,
      color: 'success'
    }
  }),
  actions: {
    hideSnackbar() {
      this.snackbar.show = false
      this.snackbar.messages = []
    },
    showSnackbar(messages: Array<string>, color: string, time: number = 5000) {
      this.snackbar.show = true
      this.snackbar.messages = messages
      this.snackbar.color = color
      setTimeout(() => {
        this.hideSnackbar()
      }, time)
    }
  },
  getters: {
    getColor() {
      switch (this.snackbar.color) {
        case 'success':
          return 'green'
        case 'error':
          return 'red'
        case 'warning':
          return 'yellow'
        case 'info':
          return 'blue'
        default:
          return 'green'
      }
    }
  }
})
